import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomModule } from '@nibtravel/shared/util/dom';
import { GtmModule } from '@nibtravel/shared/util/gtm';

import { PurchasePathDimensions } from './custom-dimension/purchase-path-dimension.service';
import {
  ItemAnalyticsService,
  OptionsAnalyticService,
  PlanAnlyticsService,
} from './services';
import { PurchasePathAnalyticsService } from './services/purchase-path-analytics.service';

@NgModule({
  imports: [CommonModule, DomModule, GtmModule],
  providers: [
    PurchasePathAnalyticsService,
    PurchasePathDimensions,
    OptionsAnalyticService,
    PlanAnlyticsService,
    ItemAnalyticsService,
    CurrencyPipe,
  ],
})
export class GtmAnalyticsModule {}
